export default __webpack_public_path__ + "static/media/LostRfp.b844184e.svg";